/**
 * Sort numbers by value and text alphabetically, numbers first: 4, 9, 10, Kitcars, X1
 * @param {number|string} a first value
 * @param {number|string} b second value
 * @returns {number} sort order
 */
export const naturalSort = ( a, b ) => String( a ).localeCompare( String( b ), 'en', { numeric: true } )

/**
 * Get the unique values of one key
 * @param {Array<Object>} data rows
 * @param {string} key key to get the values of
 * @param {Function} sort sort function, natural order by default
 * @returns {Array} unique values, sorted
 */
export const getUnique = ( data, key, sort = naturalSort ) =>
(
  [ ...new Set( data.map( d => d[ key ] ) ) ].sort( sort )
)

// numerical sort
export const numSort = ( a, b ) => ( a - b )